<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#000000"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M7 1V7M7 7V13M7 7H13M7 7H1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>
